import React from "react";
import { Bookmark } from "lucide-react";

const EmptyState = () => (
  <div className="text-center py-20">
    <Bookmark className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
    <h3 className="text-xl font-semibold text-foreground mb-2">
      No saved parts yet
    </h3>
    <p className="text-muted-foreground">
      Start browsing and save parts you're interested in!
    </p>
  </div>
);

export default EmptyState;
